import { useState } from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";
import constants from "../../../Utils/constants";
import { toHaveValue } from "@testing-library/jest-dom/matchers";
import { haveValue } from "../../../helper/common";
import LandlordProgressbar from "./LandlordProgressbar";
import { trackClarityEvent } from "../../../Utils/clarityReady";
import { Button } from "../../../components/design";

const UsageSelectionModal = ({
  progressStep,
  setCurrentStep,
  setFormData,
  formData,
}) => {
  const { _t } = useTranslator();
  const cards = [
    {
      id: constants.PERSONAL_USE,
      img: "/images/personal-use-icon.svg",
      titleKey: "personalUse",
      descKey: "willBeUsedToRentAPropertyForMyselfFamilyOrFriends",
    },
    {
      id: constants.PROFESSIONAL_USE,
      img: "/images/professional-use-icon.svg",
      titleKey: "professionalUse",
      descKey:
        "willBeUsedToRentAPropertyForMyselfFamilyOrFriendsProfessionalUse",
    },
  ];

  const [selected, setSelected] = useState(formData.skor_usage);

  const handleNextStep = () => {
    trackClarityEvent("landlord_how_to_plan_skor_step_ended");
    if (formData.skor_usage == constants.PERSONAL_USE) {
      setCurrentStep((prev) => prev + 2);
      setTimeout(() => {
        trackClarityEvent(
          "landlord_many_properties_do_you_manage_step_started"
        );
      }, constants.CLARITY_DELAY);
    } else {
      setCurrentStep((prev) => prev + 1);
      setTimeout(() => {
        trackClarityEvent("landlord_options_better_defined_you_step_started");
      }, constants.CLARITY_DELAY);
    }
  };

  const handleSelectCard = (card_id) => {
    setSelected(card_id);
    setFormData((prev) => ({ ...prev, skor_usage: card_id }));
  };

  return (
    <div>
      <Modal
        show={true}
        // onHide={handleCloseModal}
        centered
        className="landlord-onboarding-modal usage-selection-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <h4>{_t("howDoYouPlanToUseSkor")}</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{_t("pleaseSelectAnOption")}</p>
          <LandlordProgressbar step={progressStep + 1} />
          <div className="cards-comp">
            {cards.map((card) => (
              <div
                onClick={() => handleSelectCard(card.id)}
                className={`usage-card ${
                  selected === card.id ? "select-card " : ""
                }`}
                key={card.id}
              >
                <img src={card.img} alt={card.id + "-icon"} />
                <h3>{_t(card.titleKey)}</h3>
                <p>{_t(card.descKey)}</p>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            size="lg"
            onClick={handleNextStep}
            disabled={!haveValue(formData.skor_usage)}
          >
            {_t("next")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UsageSelectionModal;
